<template>
  <div :style="{
    padding: item.level === 0 ? '0 20px' : '0 0px'
  }">
    <div _flex="~ justify-center" _text="20px bold center" class="name" :style="{
      width: item.children?.length > 1 ? 100 / item.children.length + 100 / item.children.length / 2 + '%' : '100%',
    }">{{ item.name }}</div>
    <div v-if="item.children" _m="y-10px" _flex="~">
      <!-- <div :style="{
        height: '20px',
        border: '3px solid black',
        borderBottom: 'none',
      }"></div> -->
      <tree-item
        v-for="child in item.children"
        :key="child.id"
        :item="child"
      ></tree-item>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TreeItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    };
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.name {
  writing-mode: vertical-rl;
  text-orientation: upright; /* optional, can be upright */
}
</style>
